import React from "react";
import styled from "styled-components";
import { color, font } from "../templates/ui";
const StyledFormTitle = styled.div `
    position: relative;
    border-bottom: 1px solid ${color.gray.light};
    padding-bottom: 15px;
    margin-bottom: 20px;
`;
const Title = styled.h2 `
    font-size: ${font.xlarge};
    color: ${(props) => props.theme.tertiary};
`;
const FormTitle = ({ children }) => (React.createElement(StyledFormTitle, null,
    React.createElement(Title, null, children)));
export default FormTitle;
